import React, { useRef, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DataCollectionAdd from '../shared/DataCollectionAdd.js';
import DateInput from '../shared/inputs/DateInput.js';
import '../lists/ListItems.css';

const AddList = ({ onSuccess, onBack }) => {
  const { t } = useTranslation();
  const expiresAtRef = useRef('');

  // Stable component reference — defined once so DataCollectionAdd never remounts
  // the inputs when AddList re-renders, which would clear the uncontrolled name field.
  const FormElements = useCallback(function AddListFormElements() {
    const [localDate, setLocalDate] = useState('');
    const { t } = useTranslation();
    return (
      <>
        <input
          type="text"
          name="name"
          placeholder={t('lists_name_placeholder')}
          autoFocus
        />
        <DateInput
          showTime
          name="expires_at"
          required={false}
          defaultToToday={false}
          placeholder={t('lists_expires_placeholder')}
          value={localDate}
          onChange={(val) => { setLocalDate(val); expiresAtRef.current = val; }}
        />
      </>
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {onBack && (
        <button className="list-items-back" onClick={onBack}>
          ← {t('lists_all_lists')}
        </button>
      )}
      <DataCollectionAdd
        collection="lists.lists"
        getBodyFromForm={(formData) => {
          const body = { name: formData.get('name') || '' };
          if (expiresAtRef.current) body.expires_at = new Date(expiresAtRef.current).toISOString();
          return JSON.stringify(body);
        }}
        formElements={FormElements}
        onSuccess={onSuccess}
      />
    </>
  );
};

export default AddList;
